import React, {Component} from 'react';
import {connect} from 'react-redux';
import './VersionStats.css';
import handleError from '../handleError';
import jsonFetch from '../jsonFetch';

export class VersionStats extends Component {
	constructor() {
		super();
		
		this.state = {
			currentItems: []
		}
	}
	
	componentDidMount() {
		const {setID, versionNumber, versions} = this.props;
		this.getVersionData(setID, versionNumber, versions);
	}
	
	componentWillReceiveProps(nextProps) {
		if (this.props.versionNumber !== nextProps.versionNumber) {
			const {setID, versionNumber, versions} = nextProps;
			this.getVersionData(setID, versionNumber, versions);
		}
	}
	
	getVersionData(setID, versionNumber, versions) {
		const lowerVersion = versions.filter(item => item.number < versionNumber);
		if (lowerVersion.length) {
			const previousVersion = lowerVersion[0];
			
			jsonFetch(`${process.env.REACT_APP_API}/set/${setID}/version/${previousVersion.uuid}`)
				.then(json => this.setState({currentItems: json && json.items || []}))
				.catch(handleError)
		} else {
			this.setState({currentItems: []});
		}
	}
	
	render() {
		const {newItems, itemErrors, contentErrors, contentOrphans} = this.props;
		const {currentItems} = this.state;
		// Set up the content based on the children of items
		const currentContent = [];
		currentItems.forEach(item => {
			if (item.content && item.content.length) {
				item.content.forEach(c => {
					currentContent.push({
						...c,
						item_code: item.code
					});
				});
			}
		});
		
		const newContent = [];
		newItems.forEach(item => {
			if (item.content && item.content.length) {
				item.content.forEach(c => {
					newContent.push({
						...c,
						item_code: item.code
					});
				});
			}
		});
		
		const newItemCodes = newItems && newItems.length && newItems.map(item => item.code) || [];
		const currentItemCodes = currentItems && currentItems.length && currentItems.map(item => item.code) || [];
		const newContentCodes = newContent && newContent.length && newContent.map(content => `${content.item_code}-${content.code}`) || [];
		const currentContentCodes = currentContent && currentContent.length && currentContent.map(content => `${content.item_code}-${content.code}`) || [];
		
		return (
			<table className="VersionStats">
				<colgroup/>
				<colgroup span="2"/>
				<colgroup span="2"/>
				<colgroup span="2"/>
				<colgroup/>
				<colgroup/>
				<thead>
					<tr>
						<th className="item">Item</th>
						<th className="count" colSpan="2">Count</th>
						<th className="migratory" colSpan="2">Migratory</th>
						<th className="non-migratory" colSpan="2">Non-migratory</th>
						<th className="duplicate">Duplicated</th>
						<th className="orphaned">Orphaned</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td className="item">Syllabus</td>
						<td className="count">{newItemCodes.length}</td>
						<td className={`delta  ${newItemCodes.length > currentItemCodes.length ? 'increase' : (newItemCodes.length === currentItemCodes.length ? '' : 'decrease')}`}>
							{(newItemCodes.length > currentItemCodes.length ? '+' : '')}
							{newItemCodes.length - currentItemCodes.length}
						</td>
						<td className="migratory">
							{newItemCodes.filter(code => currentItemCodes.indexOf(code) !== -1).length}
						</td>
						<td className="proportion">
							{Math.round((newItemCodes.filter(code => currentItemCodes.indexOf(code) !== -1).length / newItemCodes.length) * 100) + '%'}
						</td>
						<td className="non-migratory">
							{newItemCodes.length - newItemCodes.filter(code => currentItemCodes.indexOf(code) !== -1).length}
							</td>
						<td className="proportion">
							{Math.round(((newItemCodes.length - newItemCodes.filter(code => currentItemCodes.indexOf(code) !== -1).length) / newItemCodes.length) * 100) + '%'}
						</td>
						<td className={`duplicate ${itemErrors.length > 0 ? 'error' : 'nil'}`}>
							{itemErrors.length}
						</td>
						<td className="orphaned nil">N/A</td>
					</tr>
					{newContentCodes.length ? <tr>
						<td className="item">Syllabus content</td>
						<td className="count">{newContentCodes.length}</td>
						<td className={`delta ${newContentCodes.length > currentContentCodes.length ? 'increase' : (newContentCodes.length === currentContentCodes.length ? '' : 'decrease')}`}>
							{(newContentCodes.length > currentContentCodes.length ? '+' : '')}
							{newContentCodes.length - currentContentCodes.length}
						</td>
						<td className="migratory">
							{newContentCodes.filter(code => currentContentCodes.indexOf(code) !== -1).length}
						</td>
						<td className="proportion">
							{Math.round((newContentCodes.filter(code => currentContentCodes.indexOf(code) !== -1).length / newContentCodes.length) * 100) + '%'}
						</td>
						<td className="non-migratory">
							{newContentCodes.length - newContentCodes.filter(code => currentContentCodes.indexOf(code) !== -1).length}
						</td>
						<td className="proportion">
							{Math.round(((newContentCodes.length - newContentCodes.filter(code => currentContentCodes.indexOf(code) !== -1).length) / newContentCodes.length) * 100) + '%'}
						</td>
						<td className={`duplicate ${contentErrors.length > 0 ? 'error' : 'nil'}`}>
							{contentErrors.length}
						</td>
						<td className="orphaned error">
							{contentOrphans.length}
						</td>
					</tr> : null}
				</tbody>
			</table>
		);
	}
}

const ConnectedVersionStats = connect(
	(state) => ({
		versions: state.syllabus.versions.items
	})
)(VersionStats)

export default ConnectedVersionStats;


// WEBPACK FOOTER //
// ./src/syllabus/VersionStats.js